export const ADDON_LABELS = [
  'Premium Printing',
  'Express',
  'Gift Box',
  'Gift Note',
];

const normalize = value => String(value || '').trim().toLowerCase();

const propertyValue = (line, names) => {
  const normalizedNames = names.map(normalize);
  return (Array.isArray(line?.properties) ? line.properties : [])
    .find(property => normalizedNames.includes(normalize(property?.name)))?.value;
};

const isTruthy = value => ['1', 'enabled', 'on', 'true', 'yes']
  .includes(normalize(value));

export const isAddonLine = line => {
  if (line?.is_addon === true) return true;
  const sku = normalize(line?.raw_sku || line?.sku);
  if (['premium-printing', 'express', 'express-service', 'gift', 'gift-box', 'gift-note', 'giftnote'].includes(sku)) {
    return true;
  }
  const title = normalize(line?.title || line?.name);
  return title === 'premium printing'
    || title.includes('express service')
    || title.includes('gift wrapping')
    || title === 'gift box'
    || title.includes('gift note');
};

export const getAddonLabels = record => {
  const labels = new Set(
    (Array.isArray(record?.addon_labels) ? record.addon_labels : [])
      .map(label => ADDON_LABELS.find(
        canonical => normalize(canonical) === normalize(label)
      ))
      .filter(Boolean)
  );
  const express = propertyValue(record, ['Express']);
  const giftBox = propertyValue(record, ['Gift Box', 'Gift Wrapping']);
  const giftNote = propertyValue(record, ['Gift Note']);
  const giftMessage = propertyValue(record, ['Gift Message']);

  if (record?.is_premium_printing === true) labels.add('Premium Printing');
  if (record?.is_express === true || isTruthy(express)) labels.add('Express');
  if (record?.is_gift === true || isTruthy(giftBox)) labels.add('Gift Box');
  if (
    record?.has_gift_note === true
    || isTruthy(giftNote)
    || normalize(giftMessage)
  ) {
    labels.add('Gift Note');
  }

  return ADDON_LABELS.filter(label => labels.has(label));
};
